import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../core/security';
import {VolunteerListComponent} from "./volunteer-list/volunteer-list.component";

const routes: Routes = [
    {
        path: 'volunteers',
        component: VolunteerListComponent,
        canActivate: [AuthGuard]
    }
];

@NgModule({
    declarations: [],
    imports: [CommonModule, RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class VolunteerRoutingModule {}
